import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Confirmation")
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Are you sure to change the leverage to Low? The open position will remain in miderate leverage. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, null, {
    title: _withCtx(() => [
      _createVNode(_component_t, { path: "leverage_12" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    confirmText: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "flex-1 primary",
        onClick: _ctx.submit,
        progress: _ctx.progress
      }, {
        default: _withCtx(() => [
          _createVNode(_component_t, {
            path: "leverage_15",
            custom: ""
          }, {
            default: _withCtx(({td}) => [
              _createTextVNode(_toDisplayString(td || 'Yes'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick", "progress"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_t, {
          as: "p",
          path: "leverage_13",
          args: {new: _ctx.newlever, current: _ctx.currentlever},
          class: "pb-20"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["args"])
      ])
    ]),
    _: 1
  }))
}